export default "<div [innerHTML]=\"html\"></div>\n";